import VueTippy from 'vue-tippy';

export function useTippy(app) {
    app.use(VueTippy, {
        directive: 'tippy',
        component: 'tippy',
        defaultProps: {
            zIndex: 9999999,
            placement: 'left-start',
            maxWidth: 350,
            arrow: true,
            offset: [0, 20],
            popperOptions: {
                modifiers: [
                    { name: 'hide', enabled: false },
                ],
            },
        },
    })
}
